import { useAppContext } from 'modules/common/appContext'
import Styled from './styled'
import { useEffect } from 'react'
import { useGetWealthicaUserCredentials } from 'api'
import { useAuthenticator } from '@aws-amplify/ui-react'

export default function AuthHeader() {
	const { isWealthicaContext, wealthicaContext } = useAppContext()
	const { data } = useGetWealthicaUserCredentials(wealthicaContext?.authUser?.email, isWealthicaContext)
	const authenticator = useAuthenticator()

	useEffect(() => {
		authenticator.skipVerification()
	}, [])

	useEffect(() => {
		if (data?.email && data.token && authenticator.authStatus === 'unauthenticated') {
			// auto authorize Wealthica users
			const userNameInputDOM = document.querySelector('input[name="username"]') as any
			const passwordInputDOM = document.querySelector('input[name="password"]') as any
			const submitBtnDOM = document.querySelector('button[type="submit"]') as any

			if (userNameInputDOM && passwordInputDOM && submitBtnDOM) {
				userNameInputDOM.value = data.email
				passwordInputDOM.value = data.token
				submitBtnDOM.click()
			}
		}
	}, [data, authenticator])

	return (
		<Styled.Wrapper>
			<img src="/logo.svg" />
		</Styled.Wrapper>
	)
}
